import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import Intelligence from "./pages/Intelligence";
import ArticleDetail from "./pages/ArticleDetail";
import IrelandReadiness from "./pages/IrelandReadiness";
import Resources from "./pages/Resources";
import Industries from "./pages/Industries";
import Community from "./pages/Community";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Manifesto from "./pages/Manifesto";
import Media from "./pages/Media";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-white">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Manifesto />} />
              <Route path="/manifesto" element={<Manifesto />} />
              <Route path="/home" element={<Home />} />
              <Route path="/intelligence" element={<Intelligence />} />
              <Route path="/intelligence/ireland-ai-readiness" element={<IrelandReadiness />} />
              <Route path="/intelligence/:slug" element={<ArticleDetail />} />
              <Route path="/media" element={<Media />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/community" element={<Community />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              color: "#fff",
              border: "1px solid #0A0A0A",
              borderRadius: 0,
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}
